import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { setStoredToken } from "@/lib/api";

export const SESSION_EXPIRED_EVENT = "nw:session-expired";

export function SessionExpiredDialog() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const h = () => { if (!window.location.pathname.startsWith("/login")) setOpen(true); };
    window.addEventListener(SESSION_EXPIRED_EVENT, h);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, h);
  }, []);
  const relogin = () => {
    setStoredToken(null);
    const next = `${location.pathname}${location.search}`;
    setOpen(false);
    window.location.assign(`/login?next=${encodeURIComponent(next)}`);
  };
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="max-w-sm" data-testid="session-expired-dialog">
        <DialogHeader>
          <DialogTitle>Sessione scaduta</DialogTitle>
          <DialogDescription>Per motivi di sicurezza la sessione è terminata. Accedi di nuovo: verrai riportato alla pagina su cui stavi lavorando.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={relogin} className="bg-[#2F7D32] hover:bg-[#256628] text-white w-full" data-testid="session-expired-relogin">Accedi di nuovo</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
